import { Suspense } from "react"

import { Outlet } from "react-router-dom"

import { useAppContext } from "@/app/providers/app-provider"

import { NavigationPanel, NavigationPanelSkeleton } from "@/widgets/navigation-panel"

import { OnboardingFlowTracker } from "@/features/onboarding-analytics"

import { ErrorBoundary } from "@/shared/ui/error-boundary"

export const RootLayout = () => {
  const { shareToken } = useAppContext()

  return (
    <div className="relative min-h-dvh bg-gray-900">
      <OnboardingFlowTracker />
      <ErrorBoundary>
        <div
          className={
            shareToken ? "min-h-dvh overflow-y-auto bg-gray-900" : "min-h-dvh overflow-y-auto bg-gray-900 pb-24"
          }>
          <Outlet />
        </div>
      </ErrorBoundary>

      {!shareToken && (
        <ErrorBoundary>
          <div className="fixed bottom-0 left-0 right-0 z-40">
            <Suspense fallback={<NavigationPanelSkeleton />}>
              <NavigationPanel />
            </Suspense>
          </div>
        </ErrorBoundary>
      )}
    </div>
  )
}
